import "./AboutActivities.scss";
import React, { useMemo, useState, useEffect } from "react";
import ImageGallery from 'react-image-gallery';
import ActivitiesHeader from "./ActivitiesHeader";
import ActivitiesMain from "./ActivitiesMain";
import { getImageUrl, getThumbnailUrl } from "../../utils/imageAssets";


const AboutActivities = () => {

  // ✅ 메인 활동(텍스트는 짧고, “공식” 톤)
    const activities = useMemo(
      () => [
        {
          id: "tour",
          title: "캠퍼스 투어 운영",
          lead: "방문객에게 GIST의 연구·생활 공간을 안내하고, 캠퍼스의 분위기를 직접 전달합니다.",
          points: ["정기 투어 운영", "주요 시설/동선 안내", "방문 목적 맞춤 안내"],
          image: "/images/about/activities/01.jpeg",
          badge: "Tour",
        },
        {
          id: "admission",
          title: "입학 설명회",
          lead: "GIST 입학 정보에 대해 소개하는 시간을 갖고, 재학생의 시선으로 실제 정보를 제공합니다.",
          points: ["설명회 참여", "질의응답 지원", "입시/학사 기본 안내"],
          image: "/images/about/activities/06.jpg",
          badge: "Outreach",
        },
        {
          id: "content",
          title: "SNS 콘텐츠 제작",
          lead: "영상·카드뉴스로 GIST의 일상과 정보를 더 쉽고 빠르게 전합니다.",
          points: ["영상/카드뉴스 제작", "SNS 운영", "콘텐츠 기획"],
          image: "/images/about/activities/01.jpg",
          badge: "Media",
        },
        {
          id: "event",
          title: "교내·외 공식 행사 지원",
          lead: "공식 행사에서 안내·운영을 지원하며, 대외 협력 행사도 함께 진행합니다.",
          points: ["행사 운영 지원", "안내/동선 관리", "대외 협력 지원"],
          image: "/images/about/activities/02.jpeg",
          badge: "Event",
        },
      ],
      []
    );

  
  // 스냅샷 데이터를 react-image-gallery 형식으로 변환
  const [isFullscreen, setIsFullscreen] = useState(false);

  const snapshots = useMemo(
    () => [
      {
        original: getImageUrl("/images/snapshots/01.jpg"),
        thumbnail: getThumbnailUrl("/images/snapshots/01.jpg"),
        description: ""
      },
      {
        original: getImageUrl("/images/snapshots/01.jpeg"),
        thumbnail: getThumbnailUrl("/images/snapshots/01.jpeg"),
        description: ""
      },
      {
        original: getImageUrl("/images/snapshots/02.jpeg"),
        thumbnail: getThumbnailUrl("/images/snapshots/02.jpeg"),
        description: ""
      },
      {
        original: getImageUrl("/images/snapshots/03.jpeg"),
        thumbnail: getThumbnailUrl("/images/snapshots/03.jpeg"),
        description: ""
      },
    ],
    []
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const handleScreenChange = (isFullScreen) => {
        setIsFullscreen(isFullScreen);
        console.log(isFullScreen);
  };


  return (
    <section className="about-acts">
      <div className="about-acts__wrap">
        <ActivitiesHeader />
        <ActivitiesMain />
        
        {/* Snapshot Gallery */}
        <section className="about-acts__section">
          <div className="about-acts__sectionHead">
            <h2 className="about-acts__h2">활동 스냅샷</h2>
            <p className="about-acts__desc">활동 모습을 이미지로 확인해보세요.</p>
          </div>

          <div className="snapshot-gallery">

            <ImageGallery 
                items={snapshots}
                lazyLoad={true}
                showPlayButton={true}
                showFullscreenButton={true}
                autoPlay={false}
                onScreenChange={handleScreenChange}
                showThumbnails={false} 
            />


          </div>
        </section>

        {/* Footer mini note (텍스트 최소) */}
        <section className="about-acts__note">
          <div className="about-acts__noteGlass">
            <h3 className="about-acts__noteTitle">함께 만드는 GIST의 첫인상</h3>
            <p className="about-acts__noteText">
              지온나래는 공식 학생 홍보대사로서, 방문객과 구성원 모두에게 정확하고 따뜻한 안내를 제공하기 위해
              꾸준히 활동합니다.
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default AboutActivities;
